import { colors } from '@globals/themes/defaultTheme'
import { Announcement } from '@kudos/http-client'
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import KudosTvCard from '../KudosTvCard'
import ScrollingContent from '../ScrollingContent'

type TvAnnouncmentProps = {
  announcement: Announcement
}

const TvAnnouncement: React.FC<TvAnnouncmentProps> = ({ announcement }) => {
  return (
    <KudosTvCard
      primaryColor={colors.orangePrimary}
      icon={<CampaignOutlinedIcon />}
      postedDate={announcement.createdAt}
      postContent={
        <Stack direction="column" alignItems="center">
          <Typography mt={0} mb={5} variant="h1">
            {announcement.title}
          </Typography>
          <ScrollingContent
            htmlContent={announcement.body}
            attachmentUrls={announcement.attachmentUrls}
            maxHeight="60vh"
            contentSx={{ color: colors.grayDark, fontSize: '2rem' }}
          />
        </Stack>
      }
    />
  )
}

export default TvAnnouncement
